const formatReviewTimestamp = (date) => {
  const pad = (value) => String(value).padStart(2, '0');
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const getReviewEndpoint = () => {
  if (window.theme && window.theme.settings && window.theme.settings.review_submit_endpoint) {
    return window.theme.settings.review_submit_endpoint;
  }
  return '/apps/proxy/reviews';
};

const trackReviewEvent = (eventName, payload) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, payload);
  } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
    window.dataLayer.push({ event: eventName, ...payload });
  }
};

const getRatingValue = (ratingGroup) => {
  if (!ratingGroup) {
    return '';
  }
  const selected = ratingGroup.querySelector('input[type="radio"]:checked');
  return selected ? selected.value : '';
};

const setReviewButtonState = (button, requiredFields, ratingValue) => {
  const isComplete = requiredFields.every((field) => field && field.value && field.value.trim()) && ratingValue;
  if (button) {
    button.disabled = !isComplete;
  }
};

const applyReviewPrefill = (fields) => {
  const params = new URLSearchParams(window.location.search);
  if (fields.rating && params.get('rating')) {
    const ratingValue = params.get('rating');
    const ratingInput = fields.rating.querySelector(`input[value="${ratingValue}"]`);
    if (ratingInput) {
      ratingInput.checked = true;
    }
  }
};

const initReviewSubmission = () => {
  const root = document.querySelector('[data-review-page]');
  if (!root) {
    return;
  }

  const form = root.querySelector('[data-review-form]');
  if (!form) {
    return;
  }

  const fields = {
    rating: form.querySelector('[data-review-rating]'),
    title: form.querySelector('[data-review-title]'),
    text: form.querySelector('[data-review-text]'),
    name: form.querySelector('[data-review-name]'),
    email: form.querySelector('[data-review-email]'),
    location: form.querySelector('[data-review-location]')
  };

  const submitButton = form.querySelector('[data-review-submit]');
  const success = form.querySelector('[data-review-success]');
  const error = form.querySelector('[data-review-error]');

  applyReviewPrefill(fields);

  const requiredFields = [
    fields.text,
    fields.name,
    fields.email
  ];

  setReviewButtonState(submitButton, requiredFields, getRatingValue(fields.rating));

  form.addEventListener('input', () => {
    setReviewButtonState(submitButton, requiredFields, getRatingValue(fields.rating));
  });

  if (fields.rating) {
    fields.rating.addEventListener('change', () => {
      if (getRatingValue(fields.rating)) {
        form.classList.add('review-page__form--rating-selected');
      }
    });
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (submitButton && submitButton.disabled) {
      trackReviewEvent('review_submit_failure', { context: 'review_page', status: 'invalid' });
      return;
    }

    trackReviewEvent('review_submit_click', { context: 'review_page' });

    if (success) success.setAttribute('hidden', '');
    if (error) error.setAttribute('hidden', '');

    const payload = {
      product_handle: '',
      product_title: '',
      rating: Number(getRatingValue(fields.rating)) || 0,
      title: fields.title ? fields.title.value.trim() : '',
      text: fields.text ? fields.text.value.trim() : '',
      name: fields.name ? fields.name.value.trim() : '',
      author_email: fields.email ? fields.email.value.trim() : '',
      location: fields.location ? fields.location.value.trim() : '',
      date: formatReviewTimestamp(new Date()),
      avatar: ''
    };

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.dataset.submitting = 'true';
    }

    fetch(getReviewEndpoint(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then((response) => {
      if (!response.ok) {
        throw new Error(String(response.status || 'Review submit failed'));
      }
      return response.json().catch(() => ({}));
    }).then(() => {
      trackReviewEvent('review_submit_success', { context: 'review_page' });
      if (success) {
        success.removeAttribute('hidden');
      }
      form.classList.add('review-page__form--submitted');
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }).catch((submitError) => {
      const status = submitError && submitError.message ? submitError.message : 'network_error';
      trackReviewEvent('review_submit_failure', { context: 'review_page', status });
      if (error) {
        error.removeAttribute('hidden');
      }
    }).finally(() => {
      if (submitButton) {
        submitButton.removeAttribute('data-submitting');
        setReviewButtonState(submitButton, requiredFields);
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', initReviewSubmission);
